import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { jsonp } from '@ifeng-fe/ui_base';
import styles from './index.css';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Modal = () => {

    const [modalList, setModalList] = useState([]);

    const fetchData = async () => {
        const data = await jsonp('https://shankapi.ifeng.com/feedflow/coopdoc/strapi_1ecde77bd82b4fac2afd8aeadd29de27/info/cb', {
            jsonpCallback: 'cb',
            cache: false,
        });

        if (data.code === 0) {
            setModalList(data.data.data.slice(0, 7));
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.awards}>
            <div className={styles.modalHeader}>
                <img src="https://x0.ifengimg.com/ucms/2022_03/D6E426939B6F19BC9FFED89A1E8D0DEF88B41973_size83_w600_h206.png" alt="奖牌榜" />
                <a href="https://sports.ifeng.com/loc/special/beijing2022/awards" target="_blank" className={styles.href} rel="noreferrer">全部榜单 <img src="https://x0.ifengimg.com/ucms/2022_03/752418662FA3AA31AA4ECAB4A5E5690BD8159DA4_size0_w16_h16.png" alt="" /></a>
            </div>
            <div className={styles.tableWp}>
                <table frame="void" className={styles.modalTable}>
                    <tbody>
                        <tr>
                            <th>排名</th>
                            <th className={styles.area}>国家/地区</th>
                            <th className={styles.imgTh}><img src="https://x0.ifengimg.com/ucms/2022_03/17E50ECABF7880EC63EB03B039E86E80FF8D77C4_size4_w60_h80.png" alt="金牌" /></th>
                            <th className={styles.imgTh}><img src="https://x0.ifengimg.com/ucms/2022_03/EDE090D64A6887185E563B29261EB42415C91BEB_size4_w60_h80.png" alt="银牌" /></th>
                            <th className={styles.imgTh}><img src="https://x0.ifengimg.com/ucms/2022_03/AF9CE8947D422028BCAB5E81710D2D0EE2EFA1C3_size5_w60_h80.png" alt="铜牌" /></th>
                            <th>总数</th>
                        </tr>
                        {
                            modalList.map((modal, index) => {
                                return (
                                    <tr key={index}>
                                        <td className={cx('num', { first: modal.rank === 1, second: modal.rank === 2, third: modal.rank === 3 })}>{modal.rank}</td>
                                        <td className={styles.area}><img src={modal.url} alt={modal.country} />{modal.country}</td>
                                        <td className={styles.imgTh}>{modal.goldNum}</td>
                                        <td className={styles.imgTh}>{modal.silverNum}</td>
                                        <td className={styles.imgTh}>{modal.copperNum}</td>
                                        <td>{modal.total}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default errorBoundary(Modal);
